import React, { useState } from "react";
import StepDrawer from './StepDrawer';
import { FaPlusCircle } from 'react-icons/fa';
import DeleteModal from './DeleteModal';

function PainDiaryAttributes({
    currentStep,
    totalSteps,
    diary,
    setDiary,
    onContinue,
    close,
    back
}) {
    const [showDelete, setShowDelete] = useState(false);
    const [deleteAnswer, setDeleteAnswer] = useState('');
    const [indexToRemove, setIndexToRemove] = useState(0);

    const openDelete = (index) => {
        setIndexToRemove(index)
        if (diary.attributes[index].id) {
            setDeleteAnswer("")
            setShowDelete(true)
        } else {
            handleRemove(null, index)
        }
    }

    const closeDelete = () => {
        setShowDelete(false)
    }

    const handleChange = (index, value) => {
        const updatedMetrics = [...diary.attributes];
        updatedMetrics[index].name = value;
        setDiary({ ...diary, attributes: updatedMetrics });
    };

    const handleAdd = () => setDiary({ ...diary, attributes: [...diary.attributes, { name: "" }] });

    const handleRemove = (e, realIndex) => {
        if (e?.preventDefault) {
            e.preventDefault()
        }
        let actualIndex = indexToRemove
        if (realIndex || realIndex === 0) {
            actualIndex = realIndex
        }
        setShowDelete(false)
        if (diary.attributes.length === 1) return;
        setDiary({ ...diary, attributes: diary.attributes.filter((_, i) => i !== actualIndex) });
    };

    return (
        <div>
            <DeleteModal
                deleteAnswer={deleteAnswer}
                setDeleteAnswer={setDeleteAnswer}
                deleteAsset={handleRemove}
                showDelete={showDelete}
                deleting={false}
                closeDelete={closeDelete}
                assetType="metric"
            />
            <StepDrawer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title={diary?.id ? "Edit Your Pain Diary" : "Create Your Pain Diary"}
                disabled={diary.attributes.some(metric => !metric.name)}
                onContinue={onContinue}
                onCancel={close}
                onBack={back}
            >
                <div
                    style={{
                        maxWidth: '500px',
                        margin: '0 auto',
                    }}
                >
                    <p className="selection-hint" style={{ color: 'rgb(156, 163, 175)', margin: '1rem 0rem', textAlign: 'left' }}>
                        Enter the areas you’d like to track (e.g. Left Hip, Right Low Back).
                    </p>

                    {diary.attributes.map((metric, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '12px'
                            }}
                        >
                            <input
                                type="text"
                                value={metric.name}
                                onChange={(e) => handleChange(index, e.target.value)}
                                placeholder={`Area ${index + 1} (Can't be empty)`}
                                style={{
                                    flex: 1,
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    padding: '8px',
                                    border: metric.name.trim()
                                        ? '1px solid #ccc'
                                        : '2px solid red',
                                }}
                            />
                            <button
                                onClick={() => openDelete(index)}
                                className="clear-selection"
                                style={{
                                    visibility: diary.attributes.length < 2 ? 'hidden' : 'visible',
                                }}
                            >
                                ×
                            </button>
                        </div>
                    ))}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '20px'
                        }}
                    >
                        <button
                            className="add-new-button"
                            onClick={handleAdd}
                            style={{
                                marginTop: '0px',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                cursor: 'pointer',
                                fontSize: '1rem'
                            }}
                        >
                            <FaPlusCircle size={16} style={{ color: '#3498db' }} />
                            <span style={{ color: '#3498db' }}>Add Another Area To Track</span>
                        </button>
                    </div>
                </div>
            </StepDrawer>
        </div>
    );
}

export default PainDiaryAttributes;